import React from 'react';

import { formatMoney, toFriendlyDateString } from 'helpers/Formatter';

import { getTranslatedString, getCurrentLocale } from 'helpers/i18n';

const LeaseItem = class extends React.Component {
  render() {
    const { item } = this.props;
    if (!item) return null;

    const itemTypeTranslated = getTranslatedString(
      `tenantPortal.leaseItem.typeOfItem.${item.item_type_code}`,
      {},
      item.item_type
    );
    const itemName = item.asset_number
      ? `${itemTypeTranslated} - ${item.asset_number}`
      : itemTypeTranslated;
    const itemPricing = `${formatMoney(item.amount)}/${getTranslatedString('month')}`;

    let itemDate;
    if (item.end_date) {
      const endDate = toFriendlyDateString(item.end_date, { language: getCurrentLocale() });
      itemDate = `${getTranslatedString('leaseEnds')} ${endDate}`;
    }

    if (this.props.showLongForm) return this.renderLongForm(itemName, itemPricing, itemDate);

    return (
      <div className="row" style={{ fontSize: '15px', textTransform: 'capitalize' }}>
        <div className="col-xs-12">
          <p name={'lease-item-name'} style={{ margin: 0 }}>
            {itemName}
          </p>
        </div>
      </div>
    );
  }

  renderLongForm(itemName, itemPricing, itemDate) {
    return (
      <div className="row" style={{ fontSize: '15px', textTransform: 'capitalize' }}>
        <div className="col-xs-4">
          <p style={{ margin: 0 }}>{itemName}</p>
        </div>

        <div className="col-xs-3">
          <p style={{ margin: 0 }}>{itemPricing}</p>
        </div>

        <div className="col-xs-5">
          <p style={{ margin: 0 }}>{itemDate}</p>
        </div>
      </div>
    );
  }
};

export default LeaseItem;
